export default Object.freeze({
  /**
   * 토큰 갱신
   * 0 app_code
   * 1 mall_id
   * 2 mall_type
   * 3 shop_no
   */
  "/auth/refresh": {
    path: "/app/{0}/{1}/{2}/auth/refresh",
    method: "GET",
  },
  /**
   * 엑세스토큰 재발급 RefreshToken(shoplus_service)
   */
  /*
  "/shoplus/auth/refresh": {
    //path: "/app/shoplus/{1}/auth/refresh",
    path: "/app/shoplus/{1}/auth/refresh",
    method: "POST",
  },
  */
  /**
   * 쇼핑몰-상점-조회
   */
  "/get/shops": {
    path: "/app/{0}/{1}/{2}/shops",
    method: "GET",
  },
  /**
   * 쇼핑몰-정보-조회
   */
  "/get/store": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/store",
    method: "GET",
  },
  /**
   * 결제 타입리스트
   */
  "/api/orders/types": {
    //path: "/app/{0}/{1}/{2}/api/orders/types",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/orders/types",
    method: "GET",
  },
  /**
   * 결제 리스트 - 앱
   */
  "/api/payments": {
    //path: "/app/{0}/{1}/{2}/api/payments",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/payments",
    method: "GET",
  },
  /**
   * 결제 리스트 - 포인트
   */
  "/api/points": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/points",
    method: "GET",
  },
  /**
   * 결제
   */
  "/api/orders": {
    //path: "/app/{0}/{1}/{2}/api/orders",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/orders",
    method: "POST",
  },
  /**
   * 결제 관리 입력 정보 조회
   */
  "/api/orders/latest": {
    //path: "/app/{0}/{1}/{2}/api/orders/latest",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/payments/latest",
    method: "GET",
  },

  /**
   * 결제 관리 입력 정보 등록
   * 결제 정보 중 핸드폰 정보 없을 때 모달창으로 입력 받고 저장함
   */
  "/post/orders/latest": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/orders/latest",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/payments/latest",
    method: "POST",
  },
  /**
   * 정품인증서비스 사용정보 버전
   */
  "/cert/products/class": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/class",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/class",
    method: "GET",
  },
  /**
   * 샵의 상품조회
   */
  "/cert/products/search": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/search",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/search",
    method: "GET",
  },
  /**
   * 인증코드 상품 조회
   */
  "/cert/serials/search": {
    //path: "/app/{0}/{1}/{2}/api//cert/products/serials/search",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/serials/search",
    method: "GET",
  },
  /**
   * 정품인증 시리얼 생성
   */
  "/generate/serials": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/generate/serials",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/generate/serials",
    method: "POST",
  },
  /**
   * 정품인증 시리얼 생성 엑셀
   */
  "/generate/serials/excel": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/generate/serials/excel",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/generate/serials/excel",
    method: "POST",
  },
  /**
   * 엑셀로 부터 기존사용정품인증코드 생성
   */
  "/exists/serials/excel": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/exists/serials/excel",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/exists/serials/excel",
    method: "POST",
  },
  /**
   * 시리얼 삭제
   */
  "/serials/del": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/serials",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/serials",
    method: "DELETE",
  },
  /**
   * 정품인증 상태 조회
   */
  "/get/serials/status": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/serials/{2}/status",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/serials/{4}/status",
    method: "GET",
  },
  /**
   * 정품인증 상태 변경
   */
  "/serials/status": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/serials/{2}/status",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/serials/{4}/status",
    method: "PUT",
  },
  /**
   * 정품인증 기간 변경
   */
  "/serials/range": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/serials/{2}/range",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/serials/{4}/range",
    method: "PUT",
  },
  /**
   * 정품인증 히스토리
   */
  "/serials/history": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/serials/{2}/history",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/serials/{4}/history",
    method: "GET",
  },
  /**
   * serial sms/email 발송
   */
  "/post/send/serial/resend": {
    //path: "/app/{0}/mall/{1}/api/cert/products/lost/serials/{2}/sms",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/serials/{4}/resend",
    method: "POST",
  },
  /**
   * 분실상품 리스트
   */
  "/lost/search": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/lost/serials/search",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/lost/serials/search",
    method: "GET",
  },
  /**
   * 회원 체크
   */
  "/user/validate": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/user/{2}/validate",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/users/{4}/validate",
    method: "GET",
  },
  /**
   * 정품인증기간 가져오기
   */
  "/get/duration": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/duration",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/duration",
    method: "GET",
  },
  /**
   * 정품인증기간 등록
   */
  "/put/duration": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/duration",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/duration",
    method: "PUT",
  },
  /**
   * sms설정 가져오기
   */
  "/get/config/sms": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/sms",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/sms",
    method: "GET",
  },
  /**
   * sms설정 셋팅
   */
  "/put/config/sms": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/sms",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/sms",
    method: "PUT",
  },
  /**
   * sms 발송 이력
   */
  "/lost/serials/sms": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/lost/serials/{2}/sms",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/lost/serials/{4}/sms",
    method: "GET",
  },
  /**
   * sms 발송 이력
   */
  "/lost/serials/trial": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/lost/serials/{2}/trial",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/lost/serials/{4}/trial",
    method: "GET",
  },
  /**
   * QR 코드 인쇄 설정 가져오기
   */
  "/get/print": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/print",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/print",
    method: "GET",
  },
  /**
   * QR 코드 인쇄 설정 등록.
   */
  "/put/print": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/print",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/print",
    method: "PUT",
  },
  /**
   * QR 코드 이미지 업로드
   */
  "/post/print": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/print/images",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/print/images",
    method: "POST",
  },
  /**
   * QR 노출 문구 설정 정보 가져오기
   */
  "/get/description": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/description",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/description",
    method: "GET",
  },
  /**
   * QR 노출 문구 설정 등록
   */
  "/put/description": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/description",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/description",
    method: "PUT",
  },
  /**
   * 정품 인증 관리자 승인 설정 조회
   */
  "/get/config/approval": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/approval",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/approval",
    method: "GET",
  },

  /**
   * 정품 인증 관리자 승인 설정
   */
  "/put/config/approval": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/approval",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/approval",
    method: "PUT",
  },

  /**
   * 회원 정품 인증시 입력 항목 조회
   */
  "/get/config/authItems": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/auth_items",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/auth_items",
    method: "GET",
  },
  /**
   * 회원 정품 인증시 입력 항목 등록
   */
  "/post/config/authItems": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/auth_items",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/auth_items",
    method: "POST",
  },
  /**
   * 정품 인증 회원 관리 조회
   */
  "/get/user/search": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/users/search",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/users/search",
    method: "GET",
  },
  /**
   * 노출-설정-조회
   */
  "/get/config/display": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/display",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/display",
    method: "GET",
  },
  /**
   * 노출-설정-수정/저장
   */
  "/put/config/display": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/display",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/display",
    method: "PUT",
  },
  /**
   * 카페24-회원등급-설정-조회
   */
  "/get/groups/list": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/groups",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/groups",
    method: "GET",
  },

  /**
   * 정품-인증-코드-생성된-상품-리스트-조회
   */
  "/get/serials/products": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/serials/products",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/serials/products",
    method: "GET",
  },

  /**
   * 정품-인증시-회원등급-자동변경-설정-조회
   */
  "/get/config/groups": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/groups",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/groups",
    method: "GET",
  },

  /**
   * 정품-인증시-회원등급-자동변경-설정-등록/수정
   */
  "/put/config/groups": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/groups",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/groups",
    method: "PUT",
  },

  /**
   * 정품-인증시-적립금-지급-설정-조회
   */
  "/get/config/mileage": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/mileage",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/mileage",
    method: "GET",
  },

  /**
   * 정품-인증시-적립금-지급-설정-등록/수정
   */
  "/put/config/mileage": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/mileage",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/mileage",
    method: "PUT",
  },
  /**
   * 카페24-쿠폰-리스트-조회
   */
  "/get/coupons": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/coupons",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/coupons",
    method: "GET",
  },

  /**
   * 카페24-쿠폰-리스트-조회
   */
  "/get/config/coupons": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/coupons",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/coupons",
    method: "GET",
  },
  /**
   * 인증시 쿠폰 자동 발급 설정 등록
   */
  "/put/config/coupons": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/config/coupons",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/coupons",
    method: "PUT",
  },

  /**
   * 정품-인증-회원-관리-메모-등록/수정
   */
  "/put/serials/memo": {
    //path: "/app/{0}/{1}/{2}/api/cert/products/serials/{2}/memo",
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/serials/{4}/memo",
    method: "PUT",
  },
  /**
   * 정품-인증-쇼핑몰디자인설정
   */
  "/put/design": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/design",
    method: "PUT",
  },
  /***************** 메세지 설정 관련 API Start  */
  /**
   * 메세지-관리-설정-조회
   */
  "/get/config/message/send_type": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/send_type",
    method: "GET",
  },

  /**
   * 메세지-관리-설정-저장
   */
  "/put/config/message/send_type": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/send_type",
    method: "PUT",
  },

  /**
   * 메시지-관리-카카오채널-조회
   */
  "/get/config/kakao": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/channel",
    method: "GET",
  },
  /**
   * 메시지-관리-카카오채널추가-인증번호-발송
   */
  "/post/config/kakao/auth": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/channel",
    method: "POST",
  },
  /**
   * 메시지-관리-카카오채널추가-인증번호-입력
   */
  "/post/channel/kakao/verify": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/channel/verify",
    method: "POST",
  },

  /**
   * 메시지-관리-주문상태발송-조회
   */
  "/get/config/order/product": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/order_config",
    method: "GET",
  },
  /**
   * 메시지-관리-주문상태발송-등록/수정
   */
  "/put/config/order/product": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/order_config",
    method: "PUT",
  },
  /**
   * 메시지-관리-주문상태발송-상품-조회
   */
  "/get/search/product": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/product_search",
    method: "GET",
  },

  /**
   * 메시지-관리-메시지설정-조회
   */
  "/get/config/message": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/config",
    method: "GET",
  },
  /**
   * 메시지-관리-메시지설정-상태변경
   */
  "/put/config/message": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/config",
    method: "PUT",
  },
  /**
   * 메시지-관리-메시지설정-발송일정보-조회
   */
  "/get/config/message/add_info": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/add_info",
    method: "GET",
  },
  /**
   * 메시지-관리-메시지설정-발송일정보-등록/수정
   */
  "/put/config/message/add_info": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/add_info",
    method: "PUT",
  },

  /**
   * 메시지-관리-카카오-설정-조회
   */
  "/get/message/detail/kakao": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/detail/kakao",
    method: "GET",
  },
  /**
   * 메시지-관리-카카오-설정-저장
   */
  "/put/message/detail/kakao": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/detail/kakao",
    method: "PUT",
  },
  /**
   * 메시지-관리-카카오-검수요청
   */
  "/put/message/detail/kakao_request": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/detail/kakao_template",
    method: "PUT",
  },
  /**
   * 메시지-관리-발신자번호-조회
   */
  "/get/message/config/sender_list": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/sender_list",
    method: "GET",
  },
  /**
   * 메시지-관리-SMS-설정-조회
   */
  "/get/message/detail/sms": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/detail/sms",
    method: "GET",
  },
  /**
   * 메시지-관리-SMS-설정-저장
   */
  "/put/message/detail/sms": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/detail/sms",
    method: "PUT",
  },
  /**
   * 메시지-관리-이메일-설정-조회
   */
  "/get/message/detail/email": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/detail/email",
    method: "GET",
  },
  /**
   * 메시지-관리-이메일-설정-저장
   */
  "/put/message/detail/email": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/detail/email",
    method: "PUT",
  },
  /**
   * 메시지-관리-이메일-이미지-업로드
   */
  "/post/image": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/upload/image",
    method: "POST",
  },
  /**
   * 메시지-관리-태그사용-조회
   */
  "/get/message/detail/tag_check": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/tag_check",
    method: "GET",
  },
  /**
   * 메세지-관리-발송내역-조회
   */
  "/get/message/send_history": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/send_history",
    method: "GET",
  },
  /**
   * 메세지-관리-발송내역-상세조회
   */
  "/get/message/send_history_detail": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/send_history/{4}",
    method: "GET",
  },

  /**
   * 메세지-관리-포인트사용리스트-조회
   */
  "/get/message/point_history": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/messages/point_history",
    method: "GET",
  },
  /**
   * 디지털 인증 설정 조회
   */
  "/get/digital/config": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/info",
    method: "GET",
  },
  /**
   * 디지털 인증 설정 등록
   */
  "/put/digital/config": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/cert/products/config/info",
    method: "PUT",
  },
  /**************** 회원 관련 API Start */
  /**
   * 회원 중복 ID 체크
   */
  "/get/member/duplicate_id": {
    path: "/api/member/users/duplication",
    method: "GET",
  },
  /**
   * 회원 가입
   */
  "/post/member/signup": {
    path: "/api/member/users/signup",
    method: "POST",
  },
  /**
   * 회원 로그인
   */
  "/post/member/login": {
    path: "/api/member/users/login",
    method: "POST",
  },
  /**
   * 로그인 체크
   */
  "/get/member/login_check": {
    path: "/api/member/login_check",
    method: "GET",
  },
  /**
   * 토큰 갱신
   */
  "/post/member/refresh": {
    path: "/api/member/users/refresh",
    method: "POST",
  },
  /**
   * 회원 로그아웃
   */
  "/post/member/logout": {
    path: "/api/member/users/logout",
    method: "POST",
  },
  /**
   * 회원 정보 조회
   */
  "/get/member/profile": {
    path: "/api/member/profile",
    method: "GET",
  },
  /**
   * 회원 정보 수정
   */
  "/put/member/users": {
    path: "/api/member/users",
    method: "PUT",
  },
  /**
   * 회원 탈퇴
   */
  "/delete/member/users": {
    path: "/api/member/users",
    method: "DELETE",
  },
  /**
   * 비밀번호 찾기 (이메일 전송)
   */
  "/post/member/find_password": {
    path: "/api/member/users/find-password",
    method: "POST",
  },
  /**
   * 비밀번호 인증키 유효성 체크
   */
  "/post/member/check_reset_password": {
    path: "/api/member/users/check-reset-password",
    method: "POST",
  },
  /**
   * 비밀번호 초기화
   */
  "/put/member/reset_password": {
    path: "/api/member/users/reset-password",
    method: "PUT",
  },
  /**
   * 결제 완료 요청
   */
  "/post/payment/complete": {
    path: "/app/{0}/{1}/{2}/shops/{3}/api/payments/complete",
    method: "POST",
  },
});
